import { useSuspenseQuery } from "@tanstack/react-query";
import { listUsers } from "../openapi/api-client.ts";
import { ListUsersError } from "../errors/ListUsersError.ts";

export const useListUsers = (projectId: string) =>
  useSuspenseQuery({
    queryKey: ["users", { projectId }],
    queryFn: async () => {
      const response = await listUsers({
        path: { projectId },
      });

      if (!response.data) {
        throw new ListUsersError(
          `error while fetching users: ${response.error.message}`,
        );
      }

      return response.data;
    },
  });
